module.exports = __webpack_public_path__ + "static/media/Rotessa-corner-bottom-left.1084e023.png";